/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoneyInIDealInitOutput
 */
export interface MoneyInIDealInitOutput {
    /**
     * Transaction ID. You will this this value to confirm the transaction
     * @type {number}
     * @memberof MoneyInIDealInitOutput
     */
    id?: number;
    /**
     * Redirected URL for the client on the iDeal page payment
     * @type {string}
     * @memberof MoneyInIDealInitOutput
     */
    actionUrl?: string;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInIDealInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInIDealInitOutput interface.
 */
export function instanceOfMoneyInIDealInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInIDealInitOutputFromJSON(json: any): MoneyInIDealInitOutput {
    return MoneyInIDealInitOutputFromJSONTyped(json, false);
}

export function MoneyInIDealInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInIDealInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'actionUrl': !exists(json, 'actionUrl') ? undefined : json['actionUrl'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInIDealInitOutputToJSON(value?: MoneyInIDealInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'actionUrl': value.actionUrl,
        'error': value.error,
    };
}

